import React, { useContext, useEffect } from "react";
import gif_success from "../img/gif_success.gif";
import gif_worning from "../img/gif_worning.gif";
import "../styles/success.css";
import { useDispatch, useSelector } from "react-redux";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import { useHistory, useLocation } from "react-router-dom";
import { modeActions } from "../store/modeSlice";
import useBrazeScreenView from "../hooks/useBrazeScreenView";
import PageLayout from "../Components/PageLayout";

const Success = () => {
  useBrazeScreenView();
  const history = useHistory();
  const location = useLocation();
  const success = useSelector((state) => state.success.success);
  const languageContext = useContext(LanguageContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!sessionStorage.getItem(appConst.ORDERTOKEN)) {
      dispatch(modeActions.setValueGA4({ value: appConst.confirm_order }));
    }
    sessionStorage.removeItem(appConst.TOKEN);
  }, []);

  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.push({
          pathname: appConst.THIRTEEN_PAGE,
          search: location.search,
        });
      }
    };
  }, [history]);

  return (
    <PageLayout className="success_page">
      <div className="success success_page_content flex_column_position">
        <img src={success.isSuccess ? gif_success : gif_worning} />
        <div className="center_position">
          <div className="text_components">
            <h3>{success.title}</h3>
            <p>{success.message}</p>
          </div>
          <div className="green_component_backround order_number_component">
            <h3>{languageContext.getTranslation(appConst.ORDER_ID)}</h3>
            <h3>{success.orderID}</h3>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
export default Success;
